import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { AccountService } from "../../../services/account.service";
import {
  GeneralConfirmationModalComponent
} from "../../../components/general-confirmation-modal/general-confirmation-modal.component";
import { GeneralConfirmationModalResult } from "../../../models";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { DialogService } from "../../../services/dialog.service";

@Component({
  selector: 'cpf-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ForgotPasswordComponent {
  @Input() showBackButton = true;

  code = '';
  newPassword = '';
  confirmPassword = '';
  errors: string[] = [];

  showNewPassword = false;
  showConfirmPassword = false;

  constructor(private accountService: AccountService,
              private dialog: MatDialog,
              private translate: TranslateService,
              private router: Router,
              private dialogService: DialogService,) {

  }

  validate(): boolean {
    this.errors = []; // Clear previous errors
    const minLength = 8;

    if (!this.code) {
      this.errors.push('forgot-password.validation.code-required');
    }

    const password = this.newPassword;

    if (password.length < minLength) {
      this.errors.push('forgot-password.validation.new-password-min-length');
    }
    if (!/\d/.test(password)) {
      this.errors.push('forgot-password.validation.new-password-require-number');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      this.errors.push('forgot-password.validation.new-password-require-special');
    }
    if (!/[A-Z]/.test(password)) {
      this.errors.push('forgot-password.validation.new-password-require-uppercase');
    }
    if (!/[a-z]/.test(password)) {
      this.errors.push('forgot-password.validation.new-password-require-lowercase');
    }

    if (this.newPassword !== this.confirmPassword) {
      this.errors.push('forgot-password.validation.password-mismatch');
    }

    if (this.errors.length > 0) {
      return false;
    }

    return true;
  }

  async resetPassword() {
    if (this.validate()) {
      const response = await this.accountService.handleResetPassword({
        code: this.code,
        newPassword: this.newPassword
      });

      if (response === "error") {
        return this.showFailModal();
      } else {
        this.code = '';
        this.newPassword = '';
        this.confirmPassword = '';
        return this.showSuccessModal();
      }
    }
  }

  showFailModal() {
    this.translate.get(['forgot-password.modals.fail.title', 'forgot-password.modals.fail.message']).subscribe(translations => {
      const dialogRef = this.dialogService.openDialog(GeneralConfirmationModalComponent, {
        data: {
          title: translations['forgot-password.modals.fail.title'],
          message: translations['forgot-password.modals.fail.message'],
          confirmButton: GeneralConfirmationModalResult.Confirm
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        // Handle any post-close actions if needed
      });
    });
  }

  showSuccessModal() {
    this.translate.get(['forgot-password.modals.success.title', 'forgot-password.modals.success.message']).subscribe(translations => {
      const dialogRef = this.dialogService.openDialog(GeneralConfirmationModalComponent, {
        data: {
          title: translations['forgot-password.modals.success.title'],
          message: translations['forgot-password.modals.success.message'],
          confirmButton: GeneralConfirmationModalResult.Confirm
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.router.navigate(['calingo', 'account', 'view']);
      });
    });
  }

  navigateBack() {
    this.router.navigate(['calingo', 'account', 'view']);
  }
}
